<template>
  <ais-instant-search
    :class-names="{
      'ais-InstantSearch': 'antialiased text-14 font-montserrat max-w-full',
    }"
    :index-name="indexName"
    :key="indexName"
    :routing="routing"
    :search-client="searchClient"
    :search-function="searchFunction"
  >
    <ais-configure
      :analytics="false"
      :attributes-to-highlight.camel="jobCardAttributes"
      :attributes-to-retrieve.camel="jobCardAttributes"
      :disjunctive-facets.camel="jobFilters"
      :remove-words-if-no-result.camel="'allOptional'"
      :hits-per-page.camel="jobsPerPage * paginate"
    />
    <jobs-wrapper :jobs-per-page="jobsPerPage" :param-prop="params" />
  </ais-instant-search>
</template>

<script>
import getRouting from '../routing';
import {
  buildUiState,
  getFacets,
  buildFiltersString,
  searchClient,
  softDeletedFilter,
  storeIndexes,
} from '../utils';

import JobsWrapper from './JobsWrapper.vue';

export default {
  name: 'JobsSearch',
  computed: {
    searchClient() {
      return searchClient;
    },
  },
  components: {
    JobsWrapper,
  },
  data() {
    const vm = this;
    const params = this.paramProp;
    const indexName = params['indexes']['job'];

    return {
      params: JSON.stringify(params),
      cityAndState: this.cityAndStateProp,
      indexName,
      jobCardAttributes: [
        'id',
        'company',
        'external_url',
        'is_featured',
        'job_perks',
        'priority',
        'slug',
        'title',
        'link_out_param',
        'categories',
        ... params['job_card_attributes']
      ],
      jobFilters: getFacets(params),
      jobsPerPage: parseInt(process.env.MIX_JOBS_PER_PAGE || '25'),
      paginate: 40,
      jobsToExclude: this.jobsToExcludeProp,
      licenseType: this.licenseTypeProp,
      experienceLevels: this.experienceLevelsProp,
      onStateChange({ uiState, setUiState }) {
        setUiState(
          buildUiState(uiState, vm.indexName, uiState[vm.indexName].query),
        );
      },
      routing: getRouting({ indexName, params }),
      searchFunction(helper) {
        vm.performSearch(helper);
      },
      showBackToJobs: false,
    };
  },
  created() {
    storeIndexes(this.paramProp['indexes']);
  },
  props: {
    cityAndStateProp: {
      type: String,
      default: '',
    },
    jobsToExcludeProp: {
      type: Array,
      default: () => [],
    },
    licenseTypeProp: {
      type: String,
      default: '',
    },
    experienceLevelsProp: {
      type: Array,
      default: () => [],
    },
    paramProp: {
      default: undefined,
    },
  },
  methods: {
    async performSearch(helper) {
      const queryInUrl = decodeURIComponent(
        new URL(window.location).searchParams.get('query') || '',
      ).trim();

      const conjuctiveFilters = Array.isArray(helper.state.filters)
        ? [...helper.state.filters]
        : [];

      let query = helper.state.query;
      let page = helper.getPage();

      if (this.cityAndState) {
        query = this.cityAndState;
        this.cityAndState = '';
      }

      if (this.licenseType) {
        helper.state.disjunctiveFacetsRefinements = {
          ...helper.state.disjunctiveFacetsRefinements,
          license_types: [this.licenseType],
        };
        this.licenseType = '';
      }

      if (query && !conjuctiveFilters.length) {
        const filterString = await buildFiltersString(query);
        conjuctiveFilters.push(filterString);
      }

      if (conjuctiveFilters.length && helper.state.query) {
        helper.state.query = '';
      }
      if (this.jobsToExclude.length) {
        const companyFilter = `(company.id NOT IN [${this.jobsToExclude.join(
          ', ',
        )}])`;
        if (
          !conjuctiveFilters.length ||
          !conjuctiveFilters[0].includes(companyFilter)
        ) {
          conjuctiveFilters.push(companyFilter);
        }
      }

      if (this.experienceLevels.length) {
        const experienceLevels = Object.values(this.experienceLevels).map(value => `'${value}'`).join(', ');
        const experienceLevelsFilter = `(min_experience IN [${experienceLevels}])`;
        if (
          !conjuctiveFilters.length ||
          !conjuctiveFilters[0].includes(experienceLevelsFilter)
        ) {
          conjuctiveFilters.push(experienceLevelsFilter);
        }
      }

      if (
        !conjuctiveFilters.length ||
        !conjuctiveFilters[0].includes(softDeletedFilter)
      ) {
        conjuctiveFilters.push(softDeletedFilter);
      }

      if (this.paramProp['job_filters'].includes('for_career_site')) {
        conjuctiveFilters.push('for_career_site = false');
      }

      helper.state.filters = conjuctiveFilters
        .filter(filter => filter)
        .join(' AND ');

      if (query !== queryInUrl) {
        page = 0;
        helper.setPage(page);
      }

      helper.search();

      if (query && !helper.state.query) {
        helper.setQuery(query).setPage(page);
      }
    },
  },
};
</script>
